<div class="row">
  <div class="column" *ngFor="let image of dashBoardGallery; let i = index">
    <img class="responsive-image" [src]="image.thumb" (click)="open(i)" width="150px" height="135px" />
  </div>
</div>